import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Renders every purchased item from the authoritative grouped-order manifest.
 */
const LineItemShopOrderItemsMaybe = props => {
  const { items, intl } = props;

  if (!items) {
    return null;
  }

  const purchasedItemCount = items.reduce((count, item) => count + item.quantity, 0);

  return (
    <div className={css.shopOrderItems}>
      <p className={css.shopOrderItemCount}>
        <FormattedMessage
          id="OrderBreakdown.shopOrderItemCount"
          values={{ itemCount: purchasedItemCount }}
        />
      </p>
      {items.map(item => {
        const { listingId, quantity, title, unitPrice } = item;
        const itemTotal = new Money(unitPrice.amount * quantity, unitPrice.currency);

        return (
          <div className={css.shopOrderItem} key={listingId}>
            <span className={css.shopOrderItemTitle}>
              {title}
              {quantity > 1 ? (
                <span className={css.shopOrderItemQuantity}>
                  <FormattedMessage
                    id="OrderBreakdown.shopOrderItemQuantity"
                    values={{ quantity }}
                  />
                </span>
              ) : null}
            </span>
            <span className={css.itemValue}>{formatMoney(intl, itemTotal)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default LineItemShopOrderItemsMaybe;
